import React, { Component } from 'react';
import PropTypes from 'prop-types';

import TimeLineIcon from 'material-ui/svg-icons/action/timeline';

import ListView from '../Common/ListView.react';
import ListItem from './CourseEnrolmentListItem.react';

import CourseActions from '../../actions/CourseActionCreator';
import CourseEnrolmentStore from '../../stores/CourseEnrolmentStore';

import buildContextMenu from '../Common/BuildContextMenu';

const getMenuItems = () => [
    {
        link: '/dashboard/courses/enrolments',
        icon: <TimeLineIcon />,
        label: 'Activity',
    },
];

class CourseEnrolmentList extends Component {

    constructor() {
        super(...arguments);
        this.state = {
            courses: [],
            count: 0,
            page: 0,
            limit: 50,
            actions: [],
            links: {
                back: '/dashboard/courses',
                edit: '',
            }
        };
    }

    componentDidMount() {
        this.onChange = this.onChange.bind(this);
        CourseEnrolmentStore.addChangeListener(this.onChange);
        CourseActions.getAllEnrolments();
        this.setState({actions: buildContextMenu(getMenuItems(), this.context.auth)});
    }

    componentWillUnmount() {
        CourseEnrolmentStore.removeChangeListener(this.onChange);
    }

    render() {
        return (

            <ListView
                title="Course enrolments"
                sortOptions={this.props.sortOptions}
                sortAction={CourseActions.getAllEnrolments}
                items={this.state.courses}
                itemDecorator={ListItem}
                actions={this.state.actions}
            />
        )
    }

    onChange() {
        this.setState({ courses: CourseEnrolmentStore.getAll() });
    }
}

CourseEnrolmentList.contextTypes = {
    auth: PropTypes.object.isRequired
};

CourseEnrolmentList.defaultProps = {
    sortOptions: [
        { label: "Name", value: 'name' },
        { label: "Code", value: 'code' },
        { label: "Created", value: 'dateAdded' }
    ]
};

export default CourseEnrolmentList;
